import _ from 'lodash';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DialogService } from 'app/dialog/services/dialog.service';
import { Subject } from 'rxjs';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { CampaignService } from 'app/campaign/services';
import { PeerToPeerAmountOptionSchema } from 'app/campaign/structure/peer-to-peer';
import { moveItemInArray } from '@angular/cdk/drag-drop';
import { MdbModalRef, MdbModalService } from 'mdb-angular-ui-kit/modal';
import { P2pAmountOptionComponent } from 'app/core/components/modals/p2p-amount-option/p2p-amount-option.component';

@Component({
  selector: 'app-campaign-peer-to-peer-amount-options',
  templateUrl: './campaign-peer-to-peer-amount-options.component.html',
  styleUrls: ['./campaign-peer-to-peer-amount-options.component.scss']
})
export class CampaignPeerToPeerAmountOptionsComponent implements OnInit, OnDestroy {
  @Input() formGroupCampaignTypeData: any = null;

  public takeUntilSubject: Subject<any> = new Subject()
  public option: FormGroup = null;
  public options: FormArray = null;
  public modalRef: MdbModalRef<P2pAmountOptionComponent> | null = null;

  constructor(
    public store: Store,
    public formBuilder: FormBuilder,
    public dialogService: DialogService,
    public campaignService: CampaignService,
    public cdr: ChangeDetectorRef,
    private modalService: MdbModalService,
  ) {
    this.option = this.formBuilder.group({});
   }

  ngOnInit(): void {

    this.options = this.formGroupCampaignTypeData.get('amountOptions');
  }

  removeOption(index) {
    this.options.removeAt(index);
  }


  dropOption(event) {
    moveItemInArray(this.options.controls, event.previousIndex, event.currentIndex);
  }

  getImg(img){
    return img !== '/images/blank_2x1.png' ? img : "/images/org_logo_default_v2.svg";
  }

  addP2PAmountOption() {    
    this.modalRef =  this.modalService.open(P2pAmountOptionComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Add Amount Options',
        onClose: (data)=>{
          if(data.status){
            const group = new FormGroup({});
            this.campaignService.generateForm(group, PeerToPeerAmountOptionSchema);
            this.campaignService.initializeForm(group, data.option, PeerToPeerAmountOptionSchema);
            this.options.push(group);
            this.cdr.markForCheck();
          }
          this.modalRef.close()
        }}
      })
 
  }


  editP2PAmountOption(option, index) {
    this.modalRef =  this.modalService.open(P2pAmountOptionComponent, {
      ignoreBackdropClick: true,
      modalClass:'modal--paybee',
      containerClass:'mdb-modal-backdrop-paybee',
      data: {
        title: 'Add Percent Options',
        data:option,
        onClose: (data)=>{
          if(data.status){
            let option = this.options.controls.find((control)=>control.value.id == data.option.id)
            this.campaignService.initializeForm(option as FormGroup, data.option, PeerToPeerAmountOptionSchema);
            this.cdr.markForCheck();
          }
          this.modalRef.close()
        }
      }
    });
  }


  ngOnDestroy(): void {
    this.takeUntilSubject.next(null);
    this.takeUntilSubject.complete();
  }
}
